// our components
import {
  PermissionDeniedError,
  UnknownUserError,
  IpNotAllowed,
} from 'helpers/errors';

/**
 * @description
 * Check error from specific code
 *
 * @param {string} code - Error code.
 * @param {Array} errors - Errors.
 * @returns {undefined} No return.
 */
const checkFor = (code, errors) => errors && errors.find(e => e.code === code);

/**
 * @description
 * Check error type
 *
 * @param {Object} graphQLErrors - GraphQL errors.
 */
const checkError = ({ graphQLErrors }) => {
  // networkError is defined when the response is not a valid GraphQL response,
  // e.g. the server is completely down
  // if (networkError) {
  //   throw new ServerError();
  // }
  if (checkFor('permission-denied', graphQLErrors)) {
    throw new PermissionDeniedError();
  } else if (checkFor('unknown-user', graphQLErrors)) {
    throw new UnknownUserError();
  } else if (checkFor('ip-not-allowed', graphQLErrors)) {
    throw new IpNotAllowed();
  }
};

/**
 * @description
 * Handle GraphQL errors
 *
 * @param {Object} prop - Component props.
 */
const GraphqlErrorHandler = ({ error, children }) => {
  if (error) checkError(error);
  return children;
};

export default GraphqlErrorHandler;
